import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import styles from './css/FormHint.scss';

export default function FormHint({
    children,
    className,
    ...props
}) {
    const classes = classNames(styles.hint, className);
    return (
        <div {...props} className={classes}>
            {children}
        </div>
    );
}

FormHint.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
